import Splide from "@splidejs/splide";

export const aboutSlider = () => {
  if (!document.querySelector(".js-about-slider")) return;

  const aboutSlider = new Splide(".js-about-slider", {
    pauseOnHover: false,
    resetProgress: false,
    pagination: false,
    autoplay: true,
    arrows: false,
    type: "fade",
    rewind: true,
    interval: 5000,
    speed: 3000,
    updateOnMove: true,
  });

  aboutSlider.mount();
};
